<build-section [disabled]="disabled"
               [active]="active"
               [contentOnly]="true">
  <div class="variant-counter-item d-flex" *ngFor="let variant of variants">
    <ui-multiple-variants-counter
      class="me-3"
      [step]="step"
      [minCount]="0"
      [minCountPerProduct]="minCountPerProduct"
      [count]="countPerVariantMap?.[variant.id] || 0"
      [size]="'xs'"
      [isPlusDisabled]="disablePlus"
      [debounceTimeCount]="100"
      [btnHighlighting]="countPerVariantMap?.[variant.id] > 0"
      [calcProductCount]="calcProductCountWrapper(countPerVariantMap[variant.id] || 0)"
      (onCountUpdated)="countUpdated(variant, $event)"
    ></ui-multiple-variants-counter>

    <div>
      <div>
        <span class="fw-bold">{{variant.name}}</span>
        <span *ngIf="!disabled">, {{variant.price | tryToDiscountPrice: discount: currency}}</span>
        <span *ngIf="variant.mostPopular"
              class="ps-2 text-primary">
          ({{'cakeBuilder.cakeVariantsSection.mostPopular' | translate}})
        </span>
        <i class="variant-image-icon icon-upload-images text-primary ms-2"
           *ngIf="variant.image"
           [imagePreviewTrigger]="variant.image.original"></i>
      </div>

      <div *ngIf="variant.description"
           class="font-sm text-muted mt-1"
           [innerHTML]="variant.description">
      </div>
    </div>
  </div>
</build-section>
